// removed by extract-text-webpack-plugin
module.exports = {"overlay-drop-shadow":"overlay-drop-shadow-fe816d","sapcnqr-overlay":"sapcnqr-overlay-8d9063","sapcnqr-overlay__content":"sapcnqr-overlay__content-329fb6"};